<template>
  <div>
    <div class="row justify-content-md-center">
      <div class="col-lg-2 col-md-4">
        <div class="card pastel-green">
          <div class="card-body position-relative overflow-hidden">
            <i class="fas fa-users card-img"></i>
            <div class="card-value">
              <div class="number">{{ dashboardCounts.users }}</div>
              <div class="text">Colaboradores</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-4">
        <div class="card pastel-blue">
          <div class="card-body position-relative overflow-hidden">
            <i class="fas fa-sitemap card-img"></i>
            <div class="card-value">
              <div class="number">{{ dashboardCounts.sectors }}</div>
              <div class="text">Departamentos</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-4">
        <div class="card pastel-purple">
          <div class="card-body position-relative overflow-hidden">
            <i class="fas fa-building card-img"></i>
            <div class="card-value">
              <div class="number">{{ dashboardCounts.companies }}</div>
              <div class="text">Empresas</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-4">
        <div class="card pastel-yellow">
          <div class="card-body position-relative overflow-hidden">
            <i class="fas fa-clipboard-list card-img"></i>
            <div class="card-value">
              <div class="number">{{ dashboardCounts.ongoingResearches }}</div>
              <div class="text">Em Andamento</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-4">
        <div class="card pastel-orange">
          <div class="card-body position-relative overflow-hidden">
            <i class="fas fa-check-square card-img"></i>
            <div class="card-value">
              <div class="number">{{ dashboardCounts.asks }}</div>
              <div class="text">Perguntas</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-4">
        <div class="card pastel-red">
          <div class="card-body position-relative overflow-hidden">
            <i class="fab fa-buffer card-img"></i>
            <div class="card-value">
              <div class="number">{{ dashboardCounts.dimensions }}</div>
              <div class="text">Dimensões</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Filtros</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <div class="form-group">
                  <label>Pesquisa</label>
                  <v-select
                    label="research_name"
                    :options="researches"
                    :reduce="(researches) => researches.id"
                    v-model="filters.research_id"
                  >
                    <div slot="no-options">Pesquisa não encontrada...</div>
                  </v-select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Empresa</label>
                  <v-select
                    label="fantasy_name"
                    :options="companies"
                    :reduce="(companies) => companies.id"
                    v-model="filters.company_id"
                  >
                    <div slot="no-options">Empresa não encontrada...</div>
                  </v-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>Unidade</label>
                  <v-select
                    label="name"
                    :options="branches"
                    :reduce="(branches) => branches.id"
                    v-model="filters.branch_id"
                  >
                    <div slot="no-options">Unidade não encontrada...</div>
                  </v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Departamento</label>
                  <v-select
                    label="name"
                    :options="sectors"
                    :reduce="(sectors) => sectors.id"
                    v-model="filters.sector_id"
                  >
                    <div slot="no-options">Departamento não encontrado...</div>
                  </v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Cargo</label>
                  <v-select
                    label="name"
                    :options="roles"
                    :reduce="(roles) => roles.id"
                    v-model="filters.roles"
                  >
                    <div slot="no-options">Cargo não encontrado...</div>
                  </v-select>
                </div>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-normal btn-block mt-4"
                  @click="getResearch()"
                >
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="loading">
      <div class="col-md-12" style="font-size: 35px; text-align: center">
        <i class="fas fa-circle-notch fa-spin"></i>
      </div>
    </div>
    <div v-if="research.id && !loading" :key="research.id">
      <adderence
        :research="research"
        :workersCounter="dashboardCounts.users"
      ></adderence>

      <!-- <scale-department-chart
                v-if="research.anonymity_level !== 2"
                :research="research"
            >
            </scale-department-chart> -->

      <dimension-charts :research="research"> </dimension-charts>
      <!--
            <research-answer-charts
                :research="research"
            >
            </research-answer-charts> -->
    </div>
  </div>
</template>

<script>
import ResearchAnswerCharts from "./Reusable/ResearchAnswerCharts";
import ScaleDepartmentChart from "./Reusable/ScaleDepartmentChart";
import Adderence from "./Reusable/Adderence";
import DimensionCharts from "./Reusable/DimensionCharts.vue";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loading: false,
      research: {
        asks: [],
      },
      filters: {
        research_id: "",
        company_id: "",
        branch_id: "",
        sector_id: "",
        role_id: "",
      },
      researches: [],
      companies: [],
      branches: [],
      sectors: [],
      roles: [],
      dashboardCounts: {
        users: 0,
        companies: 0,
        sectors: 0,
        ongoingResearches: 0,
        asks: 0,
        dimensions: 0,
      },
      datetime_placeholder: moment().format("DD/MM/YYY HH:mm"),
      filter_start_date: "",
      filter_end_date: "",
    };
  },
  computed: {},
  methods: {
    revertDate(datetime) {
      if (datetime) {
        return moment(datetime, "YYYY-MM-DD HH:mm").format("DD/MM/YYYY HH:mm");
      } else {
        return "";
      }
    },
    formatDate(datetime) {
      if (datetime) {
        return moment(datetime, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD HH:mm");
      } else {
        return "";
      }
    },
    getDashboardCounts() {
      const self = this;
      const api = self.$store.state.api + "performanceDashboardCounts";
      self.$http
        .get(api)
        .then((response) => {
          self.dashboardCounts = response.data.counts;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getResearch() {
      const self = this;
      self.loading = true;

      let api = self.$store.state.api + "researches/dash-home";
      if (self.filters.research_id) {
        self.loading = true;
        api +=
          "/" +
          self.filters.research_id +
          "?company_id=" +
          self.filters.company_id +
          "&branch_id=" +
          self.filters.branch_id +
          "&sector_id=" +
          self.filters.sector_id +
          "&role_id=" +
          self.filters.role_id +
          "&start_date=" +
          self.formatDate(self.filter_start_date) +
          "&end_date=" +
          self.formatDate(self.filter_end_date);
      } else {
        self.$message("Erro", "Escolha uma pesquisa", "error");
        return;
      }
      self.$http
        .get(api)
        .then((response) => {
          self.research = response.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        })
        .finally(() => {
          self.loading = false;
        });
    },
    getResearches() {
      const self = this;
      const api = self.$store.state.api + "researches?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.researches = response.data.data;
          self.researches = self.researches.filter((x) => x.status_id !== 999);
          self.researches.map(function (el) {
            if (el.status_id == 999) {
              return (el.research_name =
                el.name +
                " - " +
                self.revertDate(el.apply_start_date) +
                " - PESQUISA CANCELADA");
            } else {
              return (el.research_name =
                el.name + " - " + self.revertDate(el.apply_start_date));
            }
          });
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getCompanies() {
      const self = this;
      const api = self.$store.state.api + "companies?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getBranches() {
      const self = this;
      const api = self.$store.state.api + "branches?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getSectors() {
      const self = this;
      const api = self.$store.state.api + "sectors?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.sectors = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getRoles() {
      const self = this;
      const api = self.$store.state.api + "roles?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.roles = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  mounted() {
    let self = this;
    self.getDashboardCounts();
    self.getResearches();
    self.getCompanies();
    self.getBranches();
    self.getSectors();
    self.getRoles();

    // if (self.$store.getters.user.type_id !== 1) {
    //   console.log(self.$store.getters.user.type_id, 'redirect to worker')
    //   this.$router.push({
    //     path: "/worker",
    //   });
    // }
  },
  components: {
    ResearchAnswerCharts,
    ScaleDepartmentChart,
    Adderence,
    DimensionCharts,
    vSelect,
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue